import React, { Ref, forwardRef } from "react";
import styled from "styled-components";
import {
  Grid,
  GridColumn as Column,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
  GridExpandChangeEvent,
  GridColumnReorderEvent
} from "@progress/kendo-react-grid";
import { State as DataState } from "@progress/kendo-data-query";
import { HeaderCell } from "./GridCells";
import { ColumnMenu } from "./ColumnMenu";
import { ColumnInterface, defaultColumns } from "./tableColumns";
import { BrokerDeal } from "../../model/BrokerDeal";

export interface DealsTableProps {
  allColumns: ColumnInterface[];
  data: BrokerDeal[];
  dataState: DataState;
  isSystemAdmin: boolean;
  onColumnChange: (columns: ColumnInterface[]) => void;
  onColumnReorder: (event: GridColumnReorderEvent) => void;
  onDataStateChange: (event: GridDataStateChangeEvent) => void;
  onGroupExpandChange: (event: GridExpandChangeEvent) => void;
  paginateData: boolean;
  totalDataLength: number;
  visibleColumns: ColumnInterface[];
}

const StyledGrid = styled(Grid)`
  height: calc(100vh - 165px);
  max-width: 1401px;
  margin: 0 auto;

  &.admin {
    height: calc(100vh - 187px);
  }

  & .k-pager-numbers .k-link {
    color: #1468A5;

    &.k-selected {
      background-color: #1468A5;
      color: white;
    }

    &:hover {
      background-color: rgba(20, 104, 165, 0.10);
      color: #1468A5;
    }

    &:focus {
      box-shadow: inset 0 0 0 2px rgba(20, 104, 165, 0.10);
    }
  }
`;

const DealsTable = forwardRef((props: DealsTableProps, ref: Ref<Grid>) => {

  const Menu = (menuProps: GridColumnMenuProps) => {
    return (
      <ColumnMenu
        {...menuProps}
        columns={props.allColumns}
        visibleColumns={props.visibleColumns}
        defaultColumnIds={defaultColumns.map(column => column.field || "")}
        onColumnsSubmit={props.onColumnChange}
      />
    );
  };

  return (
    <StyledGrid
      className={ props.isSystemAdmin ? "admin" : undefined }

      data={props.data}
      {...props.dataState}
      onDataStateChange={props.onDataStateChange}
      pageable={props.paginateData && {
        pageSizes: [100, 250, 500]
      }}
      total={props.totalDataLength}
      resizable
      sortable

      reorderable
      onColumnReorder={props.onColumnReorder}

      groupable
      onExpandChange={props.onGroupExpandChange}
      expandField="expanded"

      ref={ref}
    >
      {
        props.visibleColumns.map((column, index) => {
          return (
            <Column key={index} { ...column } headerCell={HeaderCell} columnMenu={Menu} />
          );
        })
      }
    </StyledGrid>
  );
});

export default DealsTable;
